import { AppInitState } from '@metaos/hub-sdk';
import type { AccountKey } from 'owa-client-types';

export interface CachedSidepaneState {
    appInitState: AppInitState;
    isPrecached: boolean;
}

/** Keeps track of cached sidepane states (which is only in the main window).
 * TODO: make this by sessionId, not accountkey so reads from popout do not get wrong data if called incorrectly
 */
const cachedStates = new Map<AccountKey, CachedSidepaneState>();

function getDefaultState(): CachedSidepaneState {
    return {
        appInitState: AppInitState.Unknown,
        isPrecached: false,
    };
}

export function getCachedSidepaneState(key: AccountKey): CachedSidepaneState | undefined {
    return cachedStates.get(key);
}

export function getAllCachedSidepaneStates(): ReadonlyMap<AccountKey, CachedSidepaneState> {
    return cachedStates;
}

export function initCachedSidepaneState(key: AccountKey): void {
    if (!cachedStates.has(key)) {
        cachedStates.set(key, getDefaultState());
    }
}

export function updateCachedAppInitState(key: AccountKey, state: AppInitState): void {
    const entry = cachedStates.get(key);
    if (entry) {
        entry.appInitState = state;
    }
}

export function markCachedSidepanePrecached(key: AccountKey): void {
    const entry = cachedStates.get(key);
    if (entry) {
        entry.isPrecached = true;
    }
}

export function clearCachedSidepaneIsPrecached(key: AccountKey): void {
    const entry = cachedStates.get(key);
    if (entry) {
        entry.isPrecached = false;
    }
}

// TODO: remove isPopout param, make store by sessionId
export function getCachedSidepaneStatus(
    key: AccountKey,
    isPopout: boolean
): {
    isCached: boolean;
    isPrecached: boolean;
} {
    if (isPopout) {
        return {
            isCached: false,
            isPrecached: false,
        };
    }
    const entry = cachedStates.get(key);
    return {
        isCached: entry?.appInitState === AppInitState.Cached,
        isPrecached: entry?.isPrecached ?? false,
    };
}

export function removeCachedSidepaneState(key: AccountKey): void {
    cachedStates.delete(key);
}

export function clearAllCachedSidepaneStates(): void {
    cachedStates.clear();
}
